import RegisterPasien from "../../components/RegisterPasien/RegisterOnline";

export default function Register() {
  return (
    <div style={{backgroundColor:"white"}}>
      <RegisterPasien/>
    </div>
  );
}
